import { Injectable } from '@angular/core';

import { Situacao } from "./situacao.model";
import { apiName } from "./data.service";
import { RestService } from "../../core/services/rest.service";

@Injectable()
export class SituacaoApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: Situacao, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: Situacao, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":"situacao","where":{"ativo":true}};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    this._restService.onGetPostId(apiName, objectId, {}, done);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/situacoes/situacao-api.service.ts
 **/